module.exports = "/images/start-a-promotional-offer.svg?e4ab49d128fb707093363a774847795a";